import { useTranslation } from 'react-i18next';
import { FileText } from 'lucide-react';
import { SEO, SEO_CONFIG } from '@/components/ui/SEO';

export function TermsPage() {
  const { t } = useTranslation();

  const sections = [
    'acceptance',
    'services',
    'account',
    'payment',
    'intellectual',
    'prohibited',
    'termination',
    'liability',
    'changes',
    'contact',
  ];

  return (
    <>
      <SEO {...SEO_CONFIG.terms} />
      <div className="min-h-screen">
      {/* Hero */}
      <section className="section-lg relative overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-b from-accent/5 via-transparent to-transparent" />

        <div className="container relative">
          <div className="max-w-3xl mx-auto text-center">
            <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-accent/10 border border-accent/20 text-accent text-sm mb-6">
              <FileText size={16} />
              <span>{t('terms.lastUpdated')}: 27 Aralık 2025</span>
            </div>

            <h1 className="heading-xl mb-6">
              {t('terms.title')}{' '}
              <span className="text-accent">{t('terms.titleHighlight')}</span>
            </h1>
          </div>
        </div>
      </section>

      {/* Content */}
      <section className="section">
        <div className="container">
          <div className="max-w-3xl mx-auto">
            <div className="prose prose-invert max-w-none">
              {sections.map((section) => (
                <div key={section} className="mb-8">
                  <h2 className="text-xl font-semibold mb-4 text-text-primary">
                    {t(`terms.sections.${section}.title`)}
                  </h2>
                  <p className="text-text-secondary leading-relaxed">
                    {t(`terms.sections.${section}.content`)}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
    </div>
    </>
  );
}
